/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 下载文件到本地
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  downloadDto: oss.DownloadDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "put",
    url: `/oss/file`,
    data: downloadDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
